<template>
  <div>
    <el-aside class="sidebar-wrapper sidebar-transition" :width="isCollapse ? '65px' : '170px'" :style="{
      transition: 'width 0.2s ease-out',
    }">
      <div class="sidebar-inner" :style="{
        width: isCollapse ? '65px' : '170px',
        transition: 'width 0.2s ease-out',
      }">
        <el-menu :default-active="defaultActiveIndex" class="el-menu-vertical-demo" :collapse="true">
          <template v-for="item in processedMenuData" :key="item.menuIndex">
            <!-- 存在子集菜单 -->
            <el-sub-menu v-show="item.childs.length > 0" :index="item.menuIndex + ''" popper-class="sidebar-popper">
              <!-- 二级 -->
              <template #title>
                <el-icon>
                  <component v-if="item.icon" :is="item.icon" />
                </el-icon>
                <el-row class="onelevel_menu" :index="item.name" v-show="!isCollapse">{{ item.name }}</el-row>
              </template>
              <!-- 展开三级 -->
              <div class="max_height_menu">
                <template v-for="subitem in item.childs" :key="subitem.menuIndex">
                  <el-sub-menu v-show="subitem.childs.length > 0" :index="subitem.menuIndex + ''"
                    class="menu-tow childs_heigth three-menu">
                    <template #title>
                      <div class="submenu-title">
                        <div>
                          <el-icon>
                            <component :is="subitem.icon && subitem.icon.trim() ? subitem.icon.trim() : ''" />
                          </el-icon>
                          <el-row class="onelevel_menu" :index="subitem.name">
                            {{ subitem.name }}
                          </el-row>
                        </div>
                        <span class="menu_num">{{ subitem.childs?.length ?? 0 }}</span>
                      </div>
                    </template>

                    <el-menu-item v-for="subitemChilds in subitem.childs" :key="subitemChilds.menuIndex"
                      class="childs_heigth" :index="subitemChilds.menuIndex" @click="addTabC({
                        name: item.orders.toString() + subitem.orders.toString() + subitemChilds.orders.toString(),
                        title: subitemChilds.name,
                        component: subitemChilds.componentName,
                        remarks: subitemChilds.remarks,
                        id: subitemChilds.id,
                        index: subitemChilds.menuIndex.toString(),
                      })">
                      <el-icon>
                        <component
                          :is="subitemChilds.icon && subitemChilds.icon.trim() ? subitemChilds.icon.trim() : ''" />
                      </el-icon>
                      <el-row class="onelevel_menu" :index="subitemChilds">{{ subitemChilds.name }}</el-row>
                    </el-menu-item>
                  </el-sub-menu>

                  <el-menu-item v-show="!subitem.childs.length" class="childs_heigth three-menu"
                    :index="subitem.id - subitem.studentPageId + ''" @click="addTabC({
                      name: subitem.id - subitem.studentPageId + '',
                      title: subitem.name,
                      component: subitem.componentName,
                      params: { studentPageId: subitem.studentPageId },
                      remarks: subitem.remarks,
                      id: subitem.id,
                      index: (subitem.id - (subitem.studentPageId || 0)).toString(),
                    })">
                    <el-icon>
                      <component :is="subitem.icon && subitem.icon.trim() ? subitem.icon.trim() : ''" />
                    </el-icon>
                    <el-row class="onelevel_menu" :index="subitem.name">{{ subitem.name }}</el-row>
                  </el-menu-item>
                </template>
              </div>
            </el-sub-menu>

            <!-- 不存在子菜单 -->
            <el-menu-item v-show="!item.childs.length" :index="item.menuIndex + ''" class="menu_no_child" @click="addTabC({
              name: item.id - item.studentPageId + '',
              title: item.name,
              component: item.componentName,
              params: { studentPageId: item.studentPageId },
              remarks: item.remarks,
              id: item.id,
              index: (item.id - (item.studentPageId || 0)).toString(),
            })">
              <el-icon>
                <component :is="item.icon" />
              </el-icon>
              <el-row class="onelevel_menu" :index="item.name" v-show="!isCollapse">{{ item.name }}</el-row>
            </el-menu-item>
          </template>
        </el-menu>
        <!-- 菜单右侧展开收缩按钮 -->
        <div class="sidebar-collapse-btn" :class="{ isLeftClick: isLeftClick }" :style="{
          backgroundColor: themeColor.BGThemeColor,
          transition: 'transform 0.2s ease-out',
        }" @click="openClick">
          <el-icon v-show="!isCollapse">
            <ArrowLeft></ArrowLeft>
          </el-icon>
          <el-icon v-show="isCollapse">
            <ArrowRight></ArrowRight>
          </el-icon>
        </div>
      </div>
    </el-aside>
  </div>
</template>

<script>
  import { useStore } from "vuex";
  import {
    reactive,
    ref,
    computed,
    toRefs,
    defineComponent,
    onMounted,
    nextTick,
    shallowRef,
    watch,
  } from "vue";

  import { getAuthorizeTheMenu } from "network/permissionsMenu";
  import {loginRoleInformationV2} from 'network/projectLogin'
  // import { loginRoleInformation } from "network/login";
  import { ElMessageBox } from "element-plus";


  export default defineComponent({
    emits: ["menuChange", "defaultPage", "addTab"],
    props: {
      ready: {
        type: Boolean,
        default: true, // 默认立即执行，保持向后兼容
      },
    },
    setup(props, { emit }) {
      const store = useStore();
      const userAdmin = computed(() => store.state.AdminCache);
      const menuChildsData = shallowRef([]);
      const data = reactive({
        themeColor: {},
        isCollapse: false,
        isLeftClick: false,
      });

      const processedMenuData = computed(() => menuChildsData.value);
      const defaultActiveIndex = ref('0');
      const openedMenuIndexes = ref([]);
      // 菜单索引处理
      function addMenuIndex(menuList) {
        menuList.forEach(item => {
          item.menuIndex = `${item.id}-${item.studentPageId || 0}`;
          if (item.childs && item.childs.length > 0) {
            addMenuIndex(item.childs);
          }
        });
      }
      // 查找父级菜单索引
      function findParentIndexes(menuList, targetIndex) {
        let path = [];
        function dfs(list, parents) {
          for (const item of list) {
            if (item.menuIndex === targetIndex) {
              path = [...parents, item.menuIndex];
              return true;
            }
            if (item.childs && item.childs.length) {
              if (dfs(item.childs, [...parents, item.menuIndex])) {
                return true;
              }
            }
          }
          return false;
        }
        dfs(menuList, []);
        return path.slice(0, -1); // 不包含自己
      }
      // 设置当前激活项
      function setActive(val) {
        if (defaultActiveIndex.value === val) {
          defaultActiveIndex.value = '';
          nextTick(() => {
            defaultActiveIndex.value = val;
          });
        } else {
          defaultActiveIndex.value = val;
        }
      }
      // 拉取菜单数据
      const fetchMenuData = async () => {
        try {
          const res = await getAuthorizeTheMenu();
          if (res.code !== 1) {
            ElMessageBox.alert(res.message, "提示", {
              confirmButtonText: "确定",
              type: "error",
            });
            return;
          }
          addMenuIndex(res.result.theMenuList);
          menuChildsData.value = res.result.theMenuList;
          // 设置默认页面
          sessionStorage.setItem("theMenuChilds", JSON.stringify(res.result.theMenuList));
          // 获取“订制化学员列表菜单”ID
          const useInfo = store.state.AdminCache || JSON.parse(sessionStorage.getItem("AdminCache"));
          const customStudentMenuId = useInfo?.studentPageTheMenuId;
          const defaultPage = findInTree(res.result.theMenuList, res.result.defaultTheMenuId, res.result.studentPageId);
          if (!defaultPage)
            return;
          // 判断 studentPageId 来源
          let studentPageId = defaultPage.studentPageId;
          let tabTitle = defaultPage.name;
          let componentName = defaultPage.componentName;
          let remarks = defaultPage.remarks;
          if (res.result.defaultTheMenuId === customStudentMenuId) {
            // 用后端返回的 studentPageId 订制化学员列表菜单
            let sub = null;
            if (res.result.studentPageId && res.result.studentPageId !== 0) {
              studentPageId = res.result.studentPageId;
              sub = res.result.theMenuList.find(x => x.studentPageId === studentPageId);
            } else {
              sub = defaultPage;
              studentPageId = sub.studentPageId;
            }
            if (sub) {
              tabTitle = sub.name;
              componentName = sub.componentName;
              remarks = sub.remarks;
            }
          }
          const indexValue = (defaultPage.id - (studentPageId || 0)).toString();
          // 找到当前选中项的 menuIndex
          let targetIndex = '';
          function dfs(list) {
            for (const item of list) {
              if (item.id === res.result.defaultTheMenuId && (item.studentPageId || 0) === (res.result.studentPageId || 0)) {
                targetIndex = item.menuIndex;
                return true;
              }
              if (item.childs && item.childs.length) {
                if (dfs(item.childs)) return true;
              }
            }
            return false;
          }
          dfs(res.result.theMenuList);
          defaultActiveIndex.value = indexValue;
          openedMenuIndexes.value = findParentIndexes(res.result.theMenuList, targetIndex);
          addTabC({
            name: indexValue,
            title: tabTitle,
            component: componentName,
            params: { studentPageId },
            remarks: remarks,
            id: defaultPage.id,
            index: indexValue,
          });
          defaultPage.title = tabTitle;
          sessionStorage.setItem("tabObj", JSON.stringify(defaultPage));
        } catch (error) {
          console.error('Failed to fetch menu data:', error);
        }
      };

     // 递归查找菜单项
      const findInTree = (theMenuList, defaultTheMenuId, studentPageId) => {
        const stack = [...theMenuList];
      while (stack.length) {
        const item = stack.pop();
        if (item.id === defaultTheMenuId && (item.studentPageId || 0) === (studentPageId || 0)) {
          return item;
        }
        if (item.childs?.length) {
          stack.push(...item.childs);
        }
      }
      return null;
      };

      // 添加标签页
      const addTabC = (tabObj) => {
        if (tabObj.component === 'BusinessPerformanceRank') {
          window.open("/BusinessPerformanceRank", "_blank");
          return;
        }
        emit("addTab", tabObj);
        sessionStorage.setItem("tabObj", JSON.stringify(tabObj));
        sessionStorage.setItem("tabObjDown", JSON.stringify(tabObj));
      };

      // 展开收缩按钮点击事件
      const openClick = () => {
        data.isLeftClick = !data.isLeftClick;
        data.isCollapse = !data.isCollapse;
        emit("menuChange", data.isCollapse);
      };
      // 获取登录角色信息
      const getInTheatersData = async () => {
        const adminRolesId = sessionStorage.getItem('adminRolesId');
        const res = await loginRoleInformationV2({ rolesId: adminRolesId });
        if (res.code == 1) {
          sessionStorage.setItem("AdminCache", JSON.stringify(res.result)); //存储AdminCache
          store.commit('saveUserInfoStorage', res.result);
        }

      };
      // 初始化侧边栏
      const initSideBar = async () => {
        await fetchMenuData();
        getInTheatersData();
      };
      // 标记是否已初始化，防止重复执行
      const isInitialized = ref(false);
      watch(
        () => props.ready,
        async (newVal) => {
          if (newVal && !isInitialized.value) {
            isInitialized.value = true;
            await initSideBar();
          }
        }
      );
      onMounted(async () => {
        // 如果 ready 为 true 且未初始化，立即执行
        if (props.ready && !isInitialized.value) {
          isInitialized.value = true;
          await initSideBar();
        }
      });
      return {
        setActive,
        defaultActiveIndex,
        openedMenuIndexes,
        userAdmin,
        ...toRefs(data),
        openClick,
        addTabC,
        processedMenuData,
      };
    },
  });
</script>

<style lang="scss" scoped>
  .submenu-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-right: 15px;
  }

  /* 菜单数目 */
  .menu_num {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: var(--themeColor) !important;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 12px;
    margin-left: 5px;
  }

  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 160px;
  }

  .el-sub-menu.is-opened>>>.el-sub-menu__title .el-icon-arrow-right {
    transform: rotateZ(-90deg);
  }

  .one+.el-sub-menu__icon-arrow.el-icon-arrow-down {
    transform: rotateZ(-90deg) !important;
  }

  .el-sub-menu .el-menu-item::before {
    width: 0;
  }

  /* 左侧菜单 */
  .el-aside {
    height: 100%;
  }

  .sidebar-inner {
    height: 100%;
    background-color: var(--SliderMenuColor);
    position: relative;
  }

  .sidebar-inner .el-sub-menu .el-menu-item {
    padding: 0 45px;
    min-width: 150px;
    height: 50px;
  }

  .sidebar-inner .el-menu {
    border-right: none !important;
  }

  .sidebar-inner .el-menu--collapse {
    width: 100% !important;
    background-color: var(--SliderMenuColor, #344154) !important;
    /* // color: #fff; */
  }

  /* //选中字体颜色 未选中字体、icon */
  ::v-deep .el-menu-vertical-demo .is-active .el-sub-menu__title {
    color: #333;
  }

  .el-menu-vertical-demo ::v-deep .el-sub-menu__title .onelevel_menu,
  .el-sub-menu .el-icon {
    color: var(--MenuFontColor, #333);
  }

  .el-menu-vertical-demo ::v-deep .el-sub-menu__title:hover .onelevel_menu,
  .el-sub-menu:hover .el-icon {
    color: #333;
  }

  /* // 次级菜单字体颜色 */
  .el-menu-item.is-active {
    color: var(--themeColor, #409eff) !important;
  }

  ::v-deep .el-sub-menu.is-active .onelevel_menu,
  .el-sub-menu.is-active .el-icon {

    color: var(--activeTextColor, #333);
  }

  /* // 菜单名称 */
  .onelevel_menu {
    display: inline-block;
    margin-left: 10px;
  }

  .onelevel_menu .is-active {
    color: var(--themeColor, #409eff);
  }

  .three-menu .is-active {
    color: var(--themeColor, #409eff) !important;
  }

  .el-menu--collapse .el-sub-menu,
  .el-menu--collapse .el-menu-item {
    border-bottom: 1px solid var(--UnderlineColor, #48494b);
  }

  /* // 一级菜单移入改变底色 */
  ::v-deep .el-sub-menu.is-active .el-sub-menu__title {
    /* // background-color: var(--SliderMenuColor, #131d29) !important;
  // border-bottom: 1px solid var(--activeUnderlineColor, #48494b); */
    background: #e6f0eb;
  }

  /* // 二级菜单 */
  .menu-tow ::v-deep .el-sub-menu__title:hover {
    background-color: var(--el-menu-hover-bg-color) !important;
  }

  .menu-tow ::v-deep .el-icon {
    color: #96999f;
  }

  /* // 鼠标经过竖条样式 */
  ::v-deep .el-sub-menu__title:hover::before,
  ::v-deep .menu_no_child.el-menu-item:hover::before {
    content: "";
    width: 6px;
    height: 50px;
    display: inline-block;
    background-color: var(--themeColor, #409eff) !important;
    /* // background-color: #409eff; */
    position: absolute;
    left: 0;
    z-index: 2;
    border-radius: 0px 3px 3px 0px;
  }

  /* // 二级菜单高度设置 */
  .el-sub-menu,
  .menu_no_child,
  ::v-deep .el-sub-menu__title,
  .childs_heigth.el-menu-item {
    height: 50px;
  }

  .childs_heigth {
    border-bottom: 1px solid #f2f1f1;
  }

  /* // 选中竖条色 */
  ::v-deep .sidebar-inner .is-active::before {
    content: "";
    width: 6px;
    height: 50px;
    display: inline-block;
    background-color: var(--themeColor, #409eff) !important;
    /* // background-color: #409eff; */
    position: absolute;
    left: 0;
    z-index: 2;
    border-radius: 0px 3px 3px 0px;
  }

  /* //  选中左边竖条颜色 */
  .el-menu--vertical .el-menu--popup .is-active::before {
    content: "";
    width: 6px;
    height: 50px;
    /* 竖条颜色 */
    background-color: var(--themeColor, #409eff) !important;
    position: absolute;
    left: 0;
    border-radius: 0px 3px 3px 0px;
    z-index: 9999;
  }

  /* 左侧菜单收起展开图标 */
  .sidebar-collapse-btn {
    position: fixed;
    top: 50%;
    left: 160px;
    width: 15px;
    height: 53px;
    line-height: 53px;
    text-align: center;
    margin-top: -40px;
    border: 1px soid #409eff;
    border-radius: 0 10px 10px 0;
    cursor: pointer;
    transition: left 0.05s;
    z-index: 9;
  }

  /* // 侧边栏隐藏按钮背景色 */
  .sidebar-collapse-btn {
    background-color: var(--SliderMenuColor, #344154);
    color: var(--textColor, #fff);
  }

  .sidebar-inner .isLeftClick {
    left: 65px;
    transition: 0.05s;
  }

  /* // 仅存在一个菜单的情况 */
  .menu_no_child,
  ::v-deep .menu_no_child .el-icon {
    color: #fff;
  }

  ::v-deep .menu_no_child .is-active {
    color: var(--activeTextColor, #409eff);
  }

  .menu_no_child.is-active {
    border-bottom: 1px solid #4f5154;
    /* // background-color: var(--SliderMenuColor, #131d29) !important; */
  }

  .menu_no_child.el-menu-item:hover {
    /* // background-color: var(--SliderMenuColor, #131d29) !important; */
    color: #333;
  }

  ::v-deep .menu_no_child:hover .el-icon {
    color: var(--activeTextColor, #333);
  }

</style>
<style>
  /* 以下样式必须放在全局css内，否则不生效 */
  .el-menu--popup {
    padding: 0 !important;
  }

  /* 专门针对菜单组件的弹出层缩放 - 使用更精确的选择器 */
  @media screen and (max-height: 768px) {

    /* 针对sidebar-popper的精确缩放 */
    .el-popper.sidebar-popper {
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      backface-visibility: hidden;
      transform: scale3d(0.68, 0.68, 1) !important;
      transform-origin: 0 0 !important;
    }

    .max_height_menu {
      max-height: 100% !important;
      overflow-y: auto;
      padding: 5px 0;
    }

  }



  .max_height_menu {
    max-height: 98vh;
    overflow-y: auto;
    padding: 5px 0;
  }

  .el-menu--vertical .el-menu-item.is-active {
    background-color: var(--el-menu-hover-bg-color);
  }

  .el-menu-item i {
    color: #909399;
  }

  .el-menu--popup-container {
    margin-left: -6px;
  }

  .blue {
    color: var(--themeColor, #409eff);
  }

  .hover-sty:hover {
    color: var(--themeColor, #409eff);
  }
</style>